// The label a video carries in the Bunny dashboard. Bunny videos have no
// filename -- each is addressed by the GUID Bunny generates -- so this string
// has exactly one job: let a human find the right video by eye.
//
// It matters most during a replacement. The park mechanism keeps the outgoing
// video in the library until the incoming one finishes encoding, so for that
// window two videos for the same topic sit side by side. The timestamp is
// what tells them apart.

export const MAX_TOPIC_NAME_LENGTH = 80;

/**
 * @param {number} value
 * @return {string} two-digit, zero-padded
 */
function pad(value) {
  return String(value).padStart(2, '0');
}

/**
 * Local time, `YYYY-MM-DD HH:mm`. Local rather than UTC because the person
 * comparing this against a clock is in the same timezone as the browser.
 * @param {Date} date
 * @return {string}
 */
function stamp(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    ` ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/**
 * Build the Bunny title for one upload.
 *
 * Pure by design: the caller captures `uploadedAt` once when the file is
 * chosen and reuses the returned string for every ticket request, including
 * the refreshTicket call that fires when a 24-hour TUS signature expires
 * mid-transfer. Recomputing the time there would rename a video partway
 * through its own upload.
 *
 * @param {{subjectCode: string, unitSeq: (number|string),
 *   topicNo: (number|string), topicName: ?string, topicId: string,
 *   uploadedAt: Date}} args
 * @return {string}
 */
export function buildBunnyTitle({subjectCode, unitSeq, topicNo, topicName, topicId, uploadedAt}) {
  const name = String(topicName == null ? '' : topicName)
    .slice(0, MAX_TOPIC_NAME_LENGTH)
    .trim();

  return `${subjectCode} U${unitSeq} T${topicNo} ${name}` +
    ` [${stamp(uploadedAt)}] (${topicId})`;
}
